import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCLThl3-pHjrs9qGjEHNtFVqKYRLMPLrn4",
  authDomain: "transport-pwa.firebaseapp.com",
  projectId: "transport-pwa",
  storageBucket: "transport-pwa.appspot.com",
  messagingSenderId: "194097878161",
  appId: "1:194097878161:web:55d2842957698ef34f9b30",
  measurementId: "G-RKRM00DFX1",
};
initializeApp(firebaseConfig);

const VAPID_KEY =
  "BI6DW7YMDYyJVVBsIJI_YT6smTHGH3S4PRhfJHsqm0F-V6A5TbVSP7Gzd_xawWeF-8XT3eHuOCKK8lWR1ypdoqk";

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const notificationEnable = await Notification.requestPermission();
  if (notificationEnable !== "granted") {
    console.log("Notifications are disabled or rejected by the user.");
    return "";
  }
  let fcmToken = localStorage.getItem("fcmToken");
  if (fcmToken) {
    return fcmToken;
  } else {
    try {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (token) {
        localStorage.setItem("fcmToken", token);
      }
      return token || "";
    } catch (error) {
      console.error("Error retrieving token:", error);
      return "";
    }
  }
};
